import React from 'react';
import { Input } from 'antd';

export default function PhoneComponent({
    value = '',
    onChange,
    prefix = '+228',
    maxLength = 8,
}) {
    const handleChange = (e) => {
        let val = e.target.value;

        // Supprimer tout sauf les chiffres
        val = val.replace(/\D/g, '');

        // Appliquer la limite
        if (val.length > maxLength) {
            val = val.slice(0, maxLength);
        }

        onChange?.(val);
    };

    return (
        <Input
            addonBefore={prefix}
            value={value}
            onChange={handleChange}
            placeholder="xxxxxxxx"
        />
    );
}